export function splitInputByLinesAndApplyCallBack(input, callback) {
  var inputSplittedByLines = input.split("\n");
  inputSplittedByLines = inputSplittedByLines.map(function (inputLine) {
    return callback(inputLine);
  });
  return inputSplittedByLines.join("\n");
}